import axios from 'axios';
import { get, post, put, remove } from './mainApi';

const roleServiceBaseURL = process.env.REACT_APP_ROLE_MANAGEMENT_ENDPOINT;

export const getAllRoles = async () => {
  var response = get(roleServiceBaseURL + 'roles');
  return response;
};

export const getFieldsByType = async (type: string) => {
  var response = get(`${roleServiceBaseURL}fields?name=${type}`);
  return response;
};

export const getPermissionByType = async (type: string) => {
  var response = get(`${roleServiceBaseURL}permission?name=${type}`);
  return response;
};

export const getRoleById = async (id: string) => {
  var response = get(`${roleServiceBaseURL}role?roleId=${id}`);
  return response;
};

export const createRole = async (data) => {
  var response = post(`${roleServiceBaseURL}create-role`, data);

  return response;
};

export const updateRole = async (data) => {
  try {
    var response = put(`${roleServiceBaseURL}update-role`, data);

    return response;
  } catch (error) {}
};

export const deleteRole = async (id) => {
  var response = remove(`${roleServiceBaseURL}delete-role?roleId=${id}`);

  return response;
};

export const searchRole = async (name) => {
  var response = get(`${roleServiceBaseURL}role/search?key=${name}`);
  return response;
};
